export const SHOP_LIST_FILE_NAME = "ShopList";
